import { ButtonPrimary } from 'fukku/Button/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import { testIds } from '../../../constants/dataTestIds'

export const WelcomeMessageFooter = ({
	onClick,
}: {
	readonly onClick: () => void
}) => {
	const { t } = useLabels()

	return (
		<ButtonPrimary
			data-testid={testIds.welcomeMessageModalButton}
			onClick={onClick}
			fullWidth
		>
			{t('club.welcome.ok.button')}
		</ButtonPrimary>
	)
}
